<template>
  <section>
    <div class="content">
      <div class="row mb-3">
        <div class="col-md-6">
          <Titulo
            title="Pagamento"
            description="Efetue o pagamento da solicitação."
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <Carrinho :title="'Informações do Plano'" :list="lista" />
        </div>
        <div class="col-md-6 mt-3 mt-md-0">
          <FormasPagamento
            :formasPagamento="formasPagamento"
            :validarAceite="false"
            :loading="loading"
            @method="efetuarpagamento"
          />
        </div>
      </div>
    </div>
    <div class="row mt-5 flex-column-reverse flex-md-row">
      <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
        <Botao
          title="Voltar"
          link="/produto/spc-conciliador/painel"
          nameClass="btn btn-outline-secondary btn-lg btn-block"
          >VOLTAR</Botao
        >
      </div>
    </div>
  </section>
</template>

<script>
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";
import Carrinho from "@/components/pagamento/Carrinho";
import FormasPagamento from "@/components/pagamento/MetodosPagamento";
export default {
  name: "VarejoInteligentePagamento",
  components: { Titulo, Botao, Carrinho, FormasPagamento },
  data() {
    return {
      produto: {
        nome: "SPC Conciliador",
        id: "SPC Conciliador",
      },
      breadcrumb: [
        {
          nome: "SPC Conciliador",
          id: "SPC Conciliador",
          link: "/produto/spc-conciliador/painel",
        },
        {
          nome: "Pagamento",
          id: "pagamento",
          produto: "SPC Conciliador",
        },
      ],
      formasPagamento: {
        cartaocredito: true,
        boleto: {
          status: true,
          msg: "",
        },
        mensalidade: true,
      },
      loading: false,
      lista: [],
      eventoId: null,
    };
  },
  methods: {
    async efetuarpagamento(payload) {
      this.loading = true;
      if (payload.type === "Boleto") {
        this.$http
          .post(`/api/Conciliador/RegistrarBoletoSpcConciliador`)
          .then((response) => {
            if (response.data.sucesso) {
              this.$toast.open({
                message:
                  "Boleto gerado com sucesso! Redirecionando para o painel do Conciliador...",
                type: "success",
              });
              setTimeout(() => {
                this.$router.push({
                  name: "painel-conciliador",
                });
              }, 2000);
              window.open(response.data.urlBoleto);
            }
          })
          .catch((error) => {
            if (error.statusCode === 401) {
              this.$router.push({ name: "login" });
            }
            this.loading = false;
            this.$toast.open({
              message: error.response.data.mensagem,
              type: "warning",
            });
          });
      } else if (payload.type === "Cartao") {
        const dadosCartao = payload.payload.dataCard;
        this.$http
          .post("/api/Conciliador/PagamentoCreditoSpcConciliador", {
            nomeCartao: dadosCartao.nomeCartao,
            numeroCartao: dadosCartao.numeroCartao,
            dataExpiracaoCartao: dadosCartao.dataExpiracaoCartao,
            codigoValidacaoCartao: dadosCartao.codigoValidacaoCartao,
          })
          .then((response) => {
            if (response.data.sucesso) {
              this.$toast.open({
                message:
                  "Pagamento finalizado com sucesso! Redirecionando o painel do Conciliador...",
                type: "success",
              });
              this.loading = false;
              setTimeout(() => {
                this.$router.push({
                  name: "painel-conciliador",
                });
              }, 2000);
            } else {
              this.loading = false;
              this.$toast.open({
                message:
                  "Erro ao processar seu pagamento, verifique os dados do cartão e tente novamente.",
                type: "warning",
              });
            }
          })
          .catch((error) => {
            if (error.statusCode === 401) {
              this.$router.push({ name: "login" });
            }
            this.loading = false;
            this.$toast.open({
              message: error.message,
              type: "warning",
            });
          });
      } else if (payload.type === "Mensalidade") {
        this.$http
          .post("/api/Conciliador/PagamentoBoletoMensalSpcConciliador")
          .then((response) => {
            if (response.data.sucesso) {
              this.$toast.open({
                message:
                  "Valor registrado no boleto mensal! Redirecionando para o painel do Conciliador...",
                type: "success",
              });
              setTimeout(() => {
                this.$router.push({
                  name: "painel-conciliador",
                });
              }, 2000);
            }
          })
          .catch((error) => {
            if (error.statusCode === 401) {
              this.$router.push({ name: "login" });
            }
            this.loading = false;
            this.$toast.open({
              message: error.response.data.mensagem,
              type: "warning",
            });
          });
      } else if (payload.type === "Debito") {
        const dadosCartao = payload.payload.dataCard;
        this.$http
          .post("/api/Conciliador/PagamentoDebitoSpcConciliador", {
            nomeCartao: dadosCartao.nomeCartao,
            numeroCartao: dadosCartao.numeroCartao,
            dataExpiracaoCartao: dadosCartao.dataExpiracaoCartao,
            codigoValidacaoCartao: dadosCartao.codigoValidacaoCartao,
          })
          .then((response) => {
            if (response.data.sucesso) {
              this.$toast.open({
                message:
                  "Pagamento finalizado com sucesso! Redirecionando o painel do Conciliador...",
                type: "success",
              });
              setTimeout(() => {
                this.$router.push({
                  name: "painel-conciliador",
                });
              }, 2000);
            }
          })
          .catch((error) => {
            if (error.statusCode === 401) {
              this.$router.push({ name: "login" });
            }
            this.loading = false;
            this.$toast.open({
              message: error.response.data.mensagem,
              type: "warning",
            });
          });
      }
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);

    this.$http
      .get("/api/Conciliador/ConsultarSpcConciliador")
      .then((response) => {
        if (response.data.dtAceite) {
          var strOperadoras = null;
          response.data.operadoras.forEach((el) => {
            strOperadoras = strOperadoras ? ", " + el.descricao : el.descricao;
          });

          this.lista.push({
            desc: response.data.plano.descricao,
            info:
              "Operadoras: " + strOperadoras + " (Taxa Adesão + Mensalidade)",
            value:
              response.data.plano.taxaAdesao + response.data.plano.mensalidade,
          });
        } else {
          this.$router.push({ name: "painel-conciliador" });
        }
      })
      .catch((error) => {
        if (error.response.status === 400) {
          this.$router.push({ name: "painel-conciliador" });
        }
        if (error.response.status === 401) {
          this.$router.push({ name: "login" });
        }

        this.loading = false;
        this.error = error.response.data.mensagem;
      });
  },
};
</script>
